import React from 'react';
import { motion } from 'framer-motion';
import { GearIcon, ShieldIcon, CheckIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function UniqueMechanism() {
  const {
    t
  } = useLanguage();
  const points = t('mechanism.points');
  return <section className="py-24 bg-brand-bg-dark relative overflow-hidden" data-id="element-327">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 rounded-full blur-3xl" data-id="element-328"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-green/5 rounded-full blur-3xl" data-id="element-329"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-330">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-331">
          <div className="text-center mb-16" data-id="element-332">
            <p className="text-brand-gold font-heading text-xl tracking-widest uppercase mb-4" data-id="element-333">
              {t('mechanism.pretitle')}
            </p>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-334">
              <GearIcon className="w-10 h-10 text-brand-gold" data-id="element-335" />
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-white" data-id="element-336">
                {t('mechanism.title')}
              </h2>
              <ShieldIcon className="w-10 h-10 text-brand-gold hidden sm:block" data-id="element-337" />
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="bg-gradient-to-br from-brand-bg-light to-brand-bg-dark border border-brand-gold/20 rounded-2xl p-8 sm:p-12 shadow-2xl" data-id="element-338">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="mb-10 text-center" data-id="element-339">
              <p className="text-2xl sm:text-3xl text-white font-medium leading-relaxed" data-id="element-340">
                <span className="text-brand-gold font-heading font-bold" data-id="element-341">
                  {t('mechanism.p1_strong')}
                </span>{' '}
                {t('mechanism.p1')}
              </p>
              <p className="text-xl text-gray-400 mt-6 max-w-2xl mx-auto" data-id="element-342">
                {t('mechanism.p2')}
              </p>
            </motion.div>

            <div className="grid gap-6 md:grid-cols-2 lg:gap-8 mt-12" data-id="element-343">
              {Array.isArray(points) && points.map((point: string, index: number) => <motion.div key={index} initial={{
              opacity: 0,
              x: index % 2 === 0 ? -30 : 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.12,
              ease: 'easeOut'
            }} className={`flex items-start gap-4 bg-brand-bg-dark/50 p-6 rounded-xl border border-brand-gold/10 ${index === points.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-344">
                    <div className="bg-brand-green/20 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-345">
                      <CheckIcon className="w-6 h-6 text-brand-green" data-id="element-346" />
                    </div>
                    <p className="text-lg sm:text-xl text-gray-200 font-medium" data-id="element-347">
                      {point}
                    </p>
                  </motion.div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}